import React from 'react';

import ResultsV2 from './ResultsV2';

const Results = () => {
  return <ResultsV2 />;
};

export default Results;
